<template>
  <div class="page">
    <p class="p1">
      我的订单
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <nut-row class="no-order" v-if="packageList.length==0">
        <nut-col :span="24" >
            <div class="flex-content">暂无订单</div>
        </nut-col>
    </nut-row>
    <div>
      <ul>
        <li class="li_class" v-for="(item,index) in packageList" :key="index">
          <div class="li-div">
            <span>{{item.orderNum}}</span>
            <span>卡数：{{item.batchOrderCount}} 张</span>
          </div>
          <div class="li-div">
            <span>支付时间：{{item.payTime}}</span>
            <span>金额：{{item.accountMoney}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { wx_userOrderList } from "@/api/api.js"; 
export default {
  data() {
    return {
      packageList:[]
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    initData(){
      wx_userOrderList().then(res =>{
        if(res.data.code == 200){
          this.packageList = res.data.data;
          this.packageList.map(item=>{
            item.payTime = item.payTime.substr(0,16);
          })
        }
      })
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    window.document.title = "我的订单";
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }
    .no-order{
      width: 100%;
      font-size: 21px;
      text-align: center;
      padding-top: 15%;
    }
    .li_class{
      padding: 5px 13px;
      width: 100%;
      height: 65px;
      font-size: 13px;
      border-bottom: 2px solid #ededed;
      .li-div{
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
      }
    }
  }
</style>

